<template>
  <div id="weixinSetting" v-loading="isLoading">
    <main class="main">
      <el-form label-position="left">
        
        <div class="form-info">
          <div class="weixin-setting">
            <div class="tit">微信公众号设置</div>
            <el-form-item
              v-for="(item,index) in publicSettings"
              :key="index"
              class="auto-height"
            >
              <div class="rules-name">{{item.displayName}}</div>
              <el-checkbox
                v-model="item.value"
                v-if="item.value===true||item.value===false||item.value==='true'||item.value==='false'"
              >{{item.displayName}}</el-checkbox>
              <el-input
                v-else
                v-model="item.value"
                clearable
                :min="0"
                :placeholder="`请输入${item.displayName}`"
              ></el-input>
            </el-form-item>
          </div>
          <div class="weixin-setting">
            <div class="tit">微信小程序设置</div>
            <el-form-item
              v-for="(item,index) in applets"
              :key="index"
              class="auto-height"
            >
              <div class="rules-name">{{item.displayName}}</div>
              <el-checkbox
                v-model="item.value"
                v-if="item.value===true||item.value===false||item.value==='true'||item.value==='false'"
              >{{item.displayName}}</el-checkbox>
              <el-input
                v-else
                v-model="item.value"
                clearable
                :min="0"
                :placeholder="`请输入${item.displayName}`"
              ></el-input>
            </el-form-item>
          </div>
          <div class="weixin-setting">
            <div class="tit">商户号设置</div>
            <el-form-item
              v-for="(item,index) in mchid"
              :key="index"
              class="auto-height"
            >
              <div class="rules-name">{{item.displayName}}</div>
              <el-checkbox
                v-model="item.value"
                v-if="item.value===true||item.value===false||item.value==='true'||item.value==='false'"
              >{{item.displayName}}</el-checkbox>
              <el-input
                v-else
                v-model="item.value"
                clearable
                :min="0"
                :placeholder="`请输入${item.displayName}`"
              ></el-input>
            </el-form-item>
          </div>
          <div class="weixin-setting">
            <div class="tit">微信code缓存设置</div>
            <el-form-item
              v-for="(item,index) in cache"
              :key="index"
              class="auto-height"
            >
              <div class="rules-name">{{item.displayName}}</div>
              <el-checkbox
                v-model="item.value"
                v-if="item.value===true||item.value===false||item.value==='true'||item.value==='false'"
              >{{item.displayName}}</el-checkbox>
              <el-input
                v-else
                v-model="item.value"
                clearable
                :min="0"
                :placeholder="`请输入${item.displayName}`"
              ></el-input>
            </el-form-item>
          </div>
          <div class="btn-group">
            <el-button type="primary" @click="weixinSubmit" :loading="isWeixinLoadingSubmit">保存</el-button>
            <el-button @click="weixinReduction" :loading="isWeixinCloaseLoading">重置</el-button>
          </div>
        </div>
      </el-form>
    </main>
  </div>
</template>

<script>
import {
  getWeixinSettings,
  updateWeixinSettings,
} from "@/http/api/system";
import { deepCopy } from "@/utils/deepCopy";
export default {
  components: {
  },
  data() {
    return {
      requireData: [],
      weixinSettings: [],
      publicSettings:[],
      applets:[],
      cache:[],
      mchid:[],
      permissions: this.$store.getters.permissions,
      isCloaseLoading: false,
      isLoadingSubmit: false,
      isWeixinCloaseLoading: false,
      isWeixinLoadingSubmit: false,
      initial: [],
      isLoading:true
    };
  },
  mounted() {
    this.getWeixinSettings();
  },
  methods: {
    
    weixinSubmit() {
      if (this.permissions["System.WeixinSettings.Update"]) {
        this.isWeixinLoadingSubmit = true;
        this.cache.map((item) => {
          this.requireData.push({
            name: item.name,
            value: item.value,
            forceToSet: true,
            isCollection: false,
          });
        });
        this.mchid.map((item) => {
          this.requireData.push({
            name: item.name,
            value: item.value,
            forceToSet: true,
            isCollection: false,
          });
        });
        this.applets.map((item) => {
          this.requireData.push({
            name: item.name,
            value: item.value,
            forceToSet: true,
            isCollection: false,
          });
        });
        this.publicSettings.map((item) => {
          this.requireData.push({
            name: item.name,
            value: item.value,
            forceToSet: true,
            isCollection: false,
          });
        });
        let settings = {
          settings: this.requireData,
        };
        // var query = '?providerName=G';
        updateWeixinSettings(
          settings,
          this.$store.getters.generateUpdateSettingsParams,providerName
        ).then((res) => {
          this.isWeixinLoadingSubmit = false;
          this.$message({
            message: res.message,
            type: "success",
          });
        });
      } else {
        this.weixinReduction();
        this.$message.warning({
          message: `您暂无微信配置权限`,
          showClose: true,
        });
      }
    },
    weixinReduction() {
      this.isWeixinCloaseLoading = true;
      this.getWeixinSettings();
      this.isWeixinCloaseLoading = false;
    },
    
    getWeixinSettings() {
      this.isLoading = true
      getWeixinSettings().then((res) => {
        res.result.map((item)=>{
          //console.log(item,111111);
          if(item.name.indexOf("WxOpen")!=-1){
            this.publicSettings.push(item)
          }else if(item.name.indexOf("App")!=-1){
            this.applets.push(item)
          }else if(item.name.indexOf("Code")!=-1){
            this.cache.push(item)
          }else if(item.name.indexOf("Key")!=-1||item.name.indexOf("Certificate")!=-1||item.name.indexOf("CodeExpirationTime")!=-1){
            this.mchid.push(item)
          }
        })
        setTimeout(()=>{
          this.isLoading = false
        },300)
        // this.weixinSettings = deepCopy(res.result);
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";

#weixinSetting {
  .main {
    min-width: 900px;
    min-height: calc(100vh - 150px);
    text-align: left;

    .form-info {
      // margin-bottom: 20px;
      border-radius: $--border-radius-base;
      padding: 26px 20px 20px;
      // box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
      background: #fff;
    }

    .weixin-setting {
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #dddddd;
      .tit {
        margin-bottom: 25px;
        font-size: 14px;
        font-weight: bold;
        color: #000;
      }
      .custom-height {
        margin-bottom: 20px;
      }
      .tips {
        margin-top: 7px;
        height: 14px;
        line-height: 14px;
        font-size: 12px;
        color: #878787;
      }

      .el-form-item {
        margin-bottom: 25px;
      }
      ::v-deep .el-form-item__content {
        .el-checkbox {
          margin-right: 0;
          .el-checkbox__label {
            padding-left: 6px;
            color: #2c3e50;
          }
        }
        .el-radio-button__inner {
          height: 30px;
          line-height: 10px;
        }
      }
      .el-input {
        width: 332px;
      }
      .prefix {
        @include flex(row, center);
        img {
          margin: 0 12px;
          width: 10px;
          height: 10px;
        }
        .el-input {
          margin-bottom: 10px;
          width: 124px;
        }
      }
      .template {
        margin: 5px 0 4px;
        height: 14px;
        line-height: 14px;
        font-size: 12px;
        color: #888;
      }
      .prefix-tips {
        height: 14px;
        line-height: 14px;
        font-size: 12px;
        color: #ff9d00;
      }
    }

    // @media (max-width: 1366px) {
    //   
    // }

    // @media (min-width: 1366px) and (max-width: 1920px) {
    //   margin: 20px 100px;
    // }

    // @media (min-width: 1920px) {
    //   margin: 20px 180px;
    // }
  }
}
</style>
